import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

// Store
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../../../core/store';

@Component({
  selector: 'app-kyd-smartphone-promo',
  templateUrl: './kyd-smartphone-promo.component.html',
  standalone: false
})
export class KydSmartphonePromoComponent implements OnInit, OnDestroy {
  public kydSmartphoneEligible$: Observable<boolean>;
  public kydSmartphoneFeatureEnabled: boolean;
  public buttonText = 'Sign Up';
  showKYDManageEnrollmentDuringMigration$: Observable<boolean>;
  isKydEnrolled$: Observable<boolean>;

  // Shared subject for completing observables
  private stop$: Subject<void> = new Subject<void>();

  constructor(private store: Store<fromRoot.RootState>) {}

  enroll() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/knowyourdrivesmartphone']
      })
    );
  }

  ngOnInit() {
    this.kydSmartphoneEligible$ = this.store.select(fromRoot.isKydSmartphoneEligible);
    this.isKydEnrolled$ = this.store.select(fromRoot.getKydSmartphoneEnrollments).pipe(
      takeUntil(this.stop$),
      map(summaries =>
        summaries.some(summary => {
          return (
            summary.enrollmentStatus === 'Enrolled' || summary.enrollmentStatus === 'Waiting Period'
          );
        })
      )
    );

    this.showKYDManageEnrollmentDuringMigration$ = combineLatest([
      this.store.select(fromRoot.isWithinKydMigrationPeriod),
      this.isKydEnrolled$
    ]).pipe(
      map(([withinMigrationPeriod, isKydEnrolled]) => withinMigrationPeriod && isKydEnrolled)
    );

    this.isKydEnrolled$.pipe(takeUntil(this.stop$)).subscribe(isKydEnrolled => {
      if (isKydEnrolled) {
        this.buttonText = 'Manage';
      }
    });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
